import React, { createRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { NavFoldersContent } from './NavFoldersContent';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { Connect, PropsFromRedux } from './NavFoldersContainer';

type Props = {
  cancelHover: (display: boolean, dropdown: string) => void;
} & PropsFromRedux;

type State = {
  showNav: boolean;
  foldersStored: boolean;
};

export class RawNavFolders extends React.Component<Props, State> {
  state: State = {
    showNav: false,
    foldersStored: false,
  };

  dropdownContainer = createRef<HTMLDivElement>();

  async componentDidMount() {
    await this.props.onLoad();
    this.setState({ foldersStored: true });
    window.addEventListener('click', this.showDropdownCallback);
    window.addEventListener('touchstart', this.showDropdownCallback);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.showDropdownCallback);
    window.removeEventListener('touchstart', this.showDropdownCallback);
  }

  showDropdownCallback = (event: any) => {
    const { cancelHover } = this.props;
    if (
      this.dropdownContainer.current &&
      !this.dropdownContainer.current.contains(event.target) &&
      this.state.showNav
    ) {
      this.setState({ showNav: false }, () => {
        cancelHover(false, 'folder');
      });
    }
  };

  openDropdown = () => {
    const { cancelHover } = this.props;

    this.setState(
      ({ showNav: prevShowNav }) => ({
        showNav: !prevShowNav,
      }),
      () => cancelHover(this.state.showNav, 'folder'),
    );
    doctrineAnalytics('Nav ButtonFolderClicked');
  };

  render() {
    return (
      <div
        ref={this.dropdownContainer}
        className="nav__item hide_on--tablet"
        onClick={this.openDropdown}
      >
        <div className="nav__item__group">
          <span>
            <FormattedMessage id="app.ui.navbar.folders" />{' '}
          </span>
        </div>
        {this.state.showNav && (
          <NavFoldersContent foldersStored={this.state.foldersStored} />
        )}
      </div>
    );
  }
}

export const NavFolders = Connect(RawNavFolders);
